import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useGetOptionTypes = function () {
    return useApiCall(function (signal) { return api.configuration.apiConfigurationOptionTypeGet({ signal: signal }); }, null, true, []);
};
